module.exports = __webpack_public_path__ + "img/consult.696c5e0b.png";